import { Col, Row, Typography } from "antd";
import React, { Dispatch, SetStateAction } from "react";
import Button from "../../../../../Button";

interface IFooterProps {
  currentStep: number;
  handleProceed: () => void;
  getConditionToDisable: () => boolean;
  setCurrentStep: Dispatch<SetStateAction<number>>;
  typePurchase: string;
  hideTerms: boolean;
  backtoRoot?: any;
}

const Footer: React.FC<IFooterProps> = ({
  currentStep,
  setCurrentStep,
  handleProceed,
  getConditionToDisable,
  typePurchase,
  hideTerms,
  backtoRoot,
}) => {
  return (
    <>
      <Row style={{ marginTop: "5px" }}>
        {currentStep !== 2 && !hideTerms && (
          <Col xs={24} sm={24} md={24}>
            <Typography.Paragraph style={{ textAlign: "center", fontSize: 12 }}>
              Ao realizar o pagamento você concorda com as{" "}
              <a
                href="https://velotax-termos-e-condicoes.s3.us-east-1.amazonaws.com/CONTRATO%20DE%20PRESTA%C3%87%C3%83O%20DE%20SERVI%C3%87OS%20IRPF%20MAIO.pdf"
                target="_blank"
                rel="noreferrer"
              >
                Condições gerais de venda
              </a>{" "}
              .
            </Typography.Paragraph>
          </Col>
        )}
      </Row>
      {currentStep !== 2 && currentStep !== 3 && <Row justify='center' style={{marginBottom: '1rem'}}>
        <Button
          size="large"
          type="primary"
          style={{width: '100%'}}
          onClick={handleProceed}
          disabled={getConditionToDisable()}
        >
          {currentStep === 0
            ? "PROSSEGUIR"
            : typePurchase === "UNIQUE"
              ? "FINALIZAR PAGAMENTO"
              : "FINALIZAR COMPRA"}
        </Button>
      </Row>}
      {currentStep <= 1 && <Row justify='center'>
        <Button
          size="large"
          style={{width: '100%'}}
          onClick={() => {
            if (currentStep === 0) {
              backtoRoot();
              return;
            }
            setCurrentStep((step) => step - 1);
          }}
        >
          VOLTAR
        </Button>
      </Row>}
    </>
  );
};

export default Footer;
